import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { MvMDefenseRoster, MvMOffenseRoster, MvMPendingAttackEntry, MvMRosterState } from './state'
import { initialMvMRosterState } from './state'

export const mvmRosterSlice = createSlice({
  name: 'mvmRoster',
  initialState: initialMvMRosterState as MvMRosterState,
  reducers: {
    mergeOffenseRoster: (state, action: PayloadAction<MvMOffenseRoster>) => {
      const p = action.payload
      const prev = state.byAttackId[p.attackId] || { attackId: p.attackId }
      state.byAttackId[p.attackId] = {
        ...prev,
        attackId: p.attackId,
        arrivesAt: p.arrivesAt ?? prev.arrivesAt,
        returnArrivesAt: p.returnArrivesAt ?? prev.returnArrivesAt,
        status: p.status ?? prev.status,
        offense: p,
      }
    },
    mergeDefenseRoster: (state, action: PayloadAction<MvMDefenseRoster>) => {
      const p = action.payload
      const prev = state.byAttackId[p.attackId] || { attackId: p.attackId }
      state.byAttackId[p.attackId] = {
        ...prev,
        attackId: p.attackId,
        arrivesAt: p.arrivesAt ?? prev.arrivesAt,
        returnArrivesAt: p.returnArrivesAt ?? prev.returnArrivesAt,
        status: p.status ?? prev.status,
        defenderAttackerBusyAutoDefense:
          p.defenderAttackerBusyAutoDefense ?? prev.defenderAttackerBusyAutoDefense,
        defense: p,
      }
    },
    hydrateMvMPendingAttacks: (state, action: PayloadAction<MvMPendingAttackEntry[]>) => {
      for (const entry of action.payload) {
        if (!entry?.attackId) continue
        const prev = state.byAttackId[entry.attackId] || { attackId: entry.attackId }
        state.byAttackId[entry.attackId] = {
          ...prev,
          ...entry,
          offense: entry.offense ?? prev.offense,
          defense: entry.defense ?? prev.defense,
        }
      }
    },
    /** Full replace from GET /mvm/pending-rosters so finished attacks disappear (hydrate alone never deletes keys). */
    setMvMPendingRostersFromServer: (state, action: PayloadAction<MvMPendingAttackEntry[]>) => {
      const next: Record<string, MvMPendingAttackEntry> = {}
      for (const entry of action.payload) {
        if (!entry?.attackId) continue
        next[entry.attackId] = entry
      }
      state.byAttackId = next
    },
    removeMvMPendingAttack: (state, action: PayloadAction<string>) => {
      delete state.byAttackId[action.payload]
    },
    clearMvMRoster: () => initialMvMRosterState,
  },
})

export const {
  mergeOffenseRoster,
  mergeDefenseRoster,
  hydrateMvMPendingAttacks,
  setMvMPendingRostersFromServer,
  removeMvMPendingAttack,
  clearMvMRoster,
} = mvmRosterSlice.actions

export default mvmRosterSlice.reducer
